// Temporary flow toggle: set to true to restore the supporting documentation step.
export const ENABLE_SUPPORTING_DOCUMENTATION = false;